import {CONVENTIONS_LOADED, REQUEST_CONVENTIONS} from "../actions/conventions.action";

const initialStates = {
    fetching: false,
    searching: false,
    loading: false,
    data: []
};

export default function conventions(state = initialStates, action ) {
    const { payload, type } = action;
    switch (type) {
        case REQUEST_CONVENTIONS:
            return { ...state, data: [], fetching: true };
        case CONVENTIONS_LOADED:
            return { ...state, data: payload, searching: false, fetching: false };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/convention.reducer.js